<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="8">
                <div class="PendingView">
                    <div class="PendingView-logo">
                        <div class="PendingView-logo-bg">
                        </div>
                        <img :src="srcLogo" alt="logo"/>
                    </div>
                    <div class="PendingView-form my-3 px-3">
                        <h1
                                class="text-primary mb-3 text-uppercase text-center">
                            società sportive
                        </h1>
                        <h2 class="text-center">
                            Il tuo profilo risulta
                        </h2>
                        <h2 class="my-4 text-center text-uppercase text-primary">
                            IN ATTESA DI APPROVAZIONE
                        </h2>
                        <p class="mt-3">
                            Il nostro staff sta provvedendo alla verifica dei dati inseriti
                        </p>
                        <p class="mt-3 text-center">
                            Non appena verrà confermato il tuo profilo, <br>
                            riceverai una email di conferma
                        </p>
                        <p class="mt-3 text-center">
                            Per qualsiasi informazione, scrivi pure a<br>
                            <a class="text-primary" href="mailto:bigliettiscuolecalcio@inter.it">
                                bigliettiscuolecalcio@inter.it
                            </a>
                        </p>
                        <inter-button
                                class="my-3"
                                label="Torna alla Login"
                                @onClick="$router.push({ name : 'auth.login'})">
                        </inter-button>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InterButton from "../../../../components/form/inter-button/InterButton";
    export default {
        name: "PendingView",
        components: {InterButton},
        data() {
            return {
                srcLogo: require('@/assets/media/logo.svg'),
            }
        },
    }
</script>

<style scoped>

</style>
